document.querySelectorAll( '.b-timeline' ).forEach( ( block ) => {

	const cardBlocks = Array.from( block.querySelectorAll( '.b-timeline__items > .wp-block-wombat-timeline-card' ) );

	if ( ! cardBlocks.length ) {

		return;

	}

	const prefersReducedMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

	if ( prefersReducedMotion || ! ( 'IntersectionObserver' in window ) ) {

		cardBlocks.forEach( ( cardBlock ) => cardBlock.classList.add( 'is-in-view' ) );
		return;

	}

	block.classList.add( 'has-scroll-animation' );

	const observer = new IntersectionObserver(
		( entries ) => {

			entries.forEach( ( entry ) => {

				if ( ! entry.isIntersecting ) {

					return;

				}

				entry.target.classList.add( 'is-in-view' );
				observer.unobserve( entry.target );

			} );

		},
		{
			rootMargin: '0px 0px -10% 0px',
			threshold: 0.2,
		}
	);

	cardBlocks.forEach( ( cardBlock ) => observer.observe( cardBlock ) );

} );
